import { render, staticRenderFns } from "./MapBookmarksAddDialog.vue?vue&type=template&id=1826e02e"
import script from "./MapBookmarksAddDialog.vue?vue&type=script&lang=js"
export * from "./MapBookmarksAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports